// Plain JS on purpose: jQuery is not loaded when this file runs (an app injects it
// several seconds later), so any jQuery call here would stop the whole file.
//
// Removed legacy jQuery code (tabs, .toggle accordions, .add_to_cart, #myModal and
// popup-close handlers): none of those elements are rendered anymore, and it crashed
// on line 1, which also stopped everything below it from ever running.
//
// Removed the ajaxCart.init() clone-replace de-dup patch: it never ran on the live
// site (see above), and enabling it would break the product page — theme.js keeps a
// reference to the add-to-cart button to update its sold-out/unavailable state.
// Double adds are blocked by the fetch guard in layout/theme.liquid instead.

// Predictive search — patches the <predictive-search> element from the minified
// theme.js instead of editing it, so a theme update keeps these fixes. Each patch
// checks the method it replaces still exists; if the theme renames them, the
// theme's own behaviour simply stays in place.
//
//   - Asks Shopify for up to 10 results PER TYPE (the default is 10 shared by
//     every type, so "wallpaper" returned 3 products); the section caps what shows.
//   - Only fetches the resource types the dropdown renders, following the
//     "Only show products in results" theme setting (the hidden type=product input).
//   - Cancels the previous request when a newer one starts, and ignores any
//     response that no longer matches the box, so a slow reply can't replace newer
//     results or reopen the dropdown after the box was cleared.
//   - Waits for MIN_CHARS characters.
//   - Doesn't re-run Shopify.theme.ajaxCart.init() / WAU.ProductGridVideo.init() on
//     every result: each call re-fetched /cart?view=ajax and added another click
//     listener to the cart icon and the add-to-cart button. They still run if the
//     results ever contain add-to-cart buttons or grid videos.
//   - Closes on Escape, outside click and tabbing away; reopens on focus; arrow
//     keys move between results; keeps aria-expanded in sync.
//   - Shows a loading indicator while a request is in flight.
//   - Before anything is typed, shows the search panel (snippets/search-panel.liquid):
//     recently viewed products and the links set up in the header section.
(function () {
  var MIN_CHARS = 2;
  // theme.js hides the results on a failed fetch without touching them, so the
  // indicator would otherwise stay on screen; drop it after this long regardless.
  var LOADING_TIMEOUT_MS = 8000;

  function resultsOf(searchEl) {
    return searchEl.querySelector('#predictive-search, #predictive-search-mobile');
  }

  function isOpen(results) {
    return results.style.display !== 'none' && results.innerHTML.trim() !== '' &&
      getComputedStyle(results).display !== 'none';
  }

  function resourceParams(searchEl) {
    var productsOnly = !!searchEl.querySelector('input[name="type"][value="product"]');
    var types = productsOnly ? 'product,collection,query' : 'product,collection,query,page,article';
    return '&resources[type]=' + types + '&resources[limit]=10&resources[limit_scope]=each';
  }

  function patchElement(proto) {
    if (typeof proto.getSearchResults !== 'function' ||
        typeof proto.open !== 'function' ||
        typeof proto.close !== 'function') return;

    var themeClose = proto.close;

    proto.onChange = function () {
      var term = this.input.value.trim();
      if (term.length >= MIN_CHARS) {
        this.getSearchResults(term);
      } else {
        this.close();
        // Back under the minimum: the box shows its panel again.
        if (this.wrPanel && document.activeElement === this.input) this.wrPanel.show();
      }
    };

    proto.getSearchResults = function (term) {
      var self = this;
      if (this.wrController) this.wrController.abort();
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      this.wrController = controller;

      var url = this.routesPredictiveSearchURL + '?q=' + encodeURIComponent(term) +
        '&section_id=predictive-search' + resourceParams(this);

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (text) {
          if (self.wrController !== controller || self.input.value.trim() !== term) return;
          var section = new DOMParser().parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search');
          if (!section) return;
          self.predictiveSearchResults.innerHTML = section.innerHTML;
          self.open();
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (self.wrController === controller) self.close();
        });
    };

    proto.open = function () {
      var results = this.predictiveSearchResults;
      if (this.wrPanel) this.wrPanel.hide();
      if (results.querySelector('.js-bg-video-wrapper') && window.WAU && WAU.ProductGridVideo) {
        WAU.ProductGridVideo.init();
      }
      if (results.querySelector('.js-ajax-submit') && window.Shopify && Shopify.theme && Shopify.theme.ajaxCart) {
        Shopify.theme.ajaxCart.init();
      }
      this.input.setAttribute('aria-expanded', 'true');
      if (window.theme && theme.Helpers && typeof theme.Helpers.fadeIn === 'function') {
        theme.Helpers.fadeIn(results);
      } else {
        results.style.display = 'block';
      }
    };

    proto.close = function () {
      if (this.wrController) {
        this.wrController.abort();
        this.wrController = null;
      }
      this.input.setAttribute('aria-expanded', 'false');
      this.predictiveSearchResults.removeAttribute('data-wr-loading');
      if (isOpen(this.predictiveSearchResults)) themeClose.call(this);
    };
  }

  // ---- Search panel: what an empty box shows ---------------------------------
  // Recently viewed products live in this shopper's browser only (localStorage);
  // product pages print their summary in #wr-recent-product (sections/header.liquid).
  var RECENT_KEY = 'wr-recently-viewed';
  var RECENT_MAX = 12;

  function readRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(RECENT_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    } catch (error) {
      // Storage blocked or full: the panel simply has nothing to show.
    }
  }

  function currentProduct() {
    var el = document.getElementById('wr-recent-product');
    if (!el) return null;
    try {
      var item = JSON.parse(el.textContent);
      return item && item.handle ? item : null;
    } catch (error) {
      return null;
    }
  }

  function recordProduct(item) {
    var list = readRecent().filter(function (entry) {
      return entry && entry.handle !== item.handle;
    });
    list.unshift({ handle: item.handle, url: item.url, title: item.title, image: item.image });
    writeRecent(list.slice(0, RECENT_MAX));
  }

  // Stored entries can be edited by anyone with the browser, so only same-site
  // links and protocol-relative / https image URLs are used.
  function isSafeLink(url) {
    return typeof url === 'string' && /^\/(?!\/)/.test(url);
  }

  function isSafeImage(src) {
    return typeof src === 'string' && /^(https:)?\/\/[^/]/.test(src);
  }

  function recentCard(item) {
    var li = document.createElement('li');
    var link = document.createElement('a');
    var media = document.createElement('span');
    var title = document.createElement('span');
    link.className = 'wr-sp__card';
    link.href = item.url;
    media.className = 'wr-sp__card-media';
    if (isSafeImage(item.image)) {
      var img = document.createElement('img');
      img.src = item.image;
      img.alt = '';
      img.width = 300;
      img.height = 300;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    title.className = 'wr-sp__card-title';
    title.textContent = item.title;
    link.appendChild(media);
    link.appendChild(title);
    li.appendChild(link);
    return li;
  }

  function setupPanel(input, results, panel) {
    var recent = panel.querySelector('[data-search-recent]');
    var track = panel.querySelector('[data-search-recent-list]');
    var prev = panel.querySelector('[data-search-recent-prev]');
    var next = panel.querySelector('[data-search-recent-next]');
    var clear = panel.querySelector('[data-search-recent-clear]');
    var hasLinks = !!panel.querySelector('[data-search-links] a[href]');
    var limit = parseInt(panel.getAttribute('data-recent-limit'), 10) || 8;
    var current = currentProduct();
    var rendered = null;

    // Rebuilds the cards only when the stored list changed since the last open.
    function renderRecent() {
      if (!recent || !track) return false;
      var items = readRecent().filter(function (item) {
        return item && item.title && isSafeLink(item.url) &&
          !(current && item.handle === current.handle);
      }).slice(0, limit);
      var key = JSON.stringify(items);
      if (key !== rendered) {
        rendered = key;
        track.textContent = '';
        items.forEach(function (item) { track.appendChild(recentCard(item)); });
        track.scrollLeft = 0;
      }
      recent.hidden = items.length === 0;
      return items.length > 0;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var end = track.scrollWidth - track.clientWidth;
      prev.hidden = track.scrollLeft <= 1;
      next.hidden = end <= 1 || track.scrollLeft >= end - 1;
    }

    function show() {
      if (input.value.trim().length >= MIN_CHARS) return;
      var hasRecent = renderRecent();
      if (!hasRecent && !hasLinks) return;
      // Swap instantly instead of letting stale results fade out under the panel.
      if (isOpen(results)) results.style.display = 'none';
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      if (hasRecent) updateArrows();
    }

    function hide() {
      if (panel.hidden) return;
      panel.hidden = true;
      if (!isOpen(results)) input.setAttribute('aria-expanded', 'false');
    }

    if (track) {
      track.addEventListener('scroll', updateArrows, { passive: true });
      [prev, next].forEach(function (button, index) {
        if (!button) return;
        button.addEventListener('click', function () {
          var direction = index === 0 ? -1 : 1;
          track.scrollBy({ left: direction * track.clientWidth * 0.8, behavior: 'smooth' });
        });
      });
    }

    if (clear) {
      clear.addEventListener('click', function () {
        writeRecent([]);
        renderRecent();
        if (!hasLinks) hide();
        input.focus();
      });
    }

    return {
      show: show,
      hide: hide,
      isOpen: function () { return !panel.hidden; },
      links: function () {
        return Array.prototype.slice.call(panel.querySelectorAll('a[href]'));
      }
    };
  }

  function initSearch(searchEl) {
    var input = searchEl.querySelector('input[name="q"]');
    var results = resultsOf(searchEl);
    if (!input || !results || searchEl.wrReady) return;
    searchEl.wrReady = true;

    // Loading indicator: on while a request is pending, off once results are injected.
    var timer;
    function clearLoading() {
      clearTimeout(timer);
      results.removeAttribute('data-wr-loading');
    }
    input.addEventListener('input', function () {
      if (input.value.trim().length >= MIN_CHARS) {
        results.setAttribute('data-wr-loading', 'true');
        clearTimeout(timer);
        timer = setTimeout(clearLoading, LOADING_TIMEOUT_MS);
      } else {
        clearLoading();
      }
    });
    new MutationObserver(clearLoading).observe(results, { childList: true });

    // The rest needs the patched element (open/close keep aria-expanded in sync).
    if (typeof searchEl.close !== 'function' || typeof searchEl.open !== 'function') return;

    var panelEl = searchEl.querySelector('[data-search-panel]');
    var panel = panelEl ? setupPanel(input, results, panelEl) : null;
    searchEl.wrPanel = panel;

    function panelOpen() {
      return !!panel && panel.isOpen();
    }

    function closeAll() {
      searchEl.close();
      if (panel) panel.hide();
    }

    // Reaching the minimum swaps the panel for results right away; going back under
    // it brings the panel back without waiting for the theme's 300ms debounce.
    if (panel) {
      input.addEventListener('input', function () {
        if (input.value.trim().length >= MIN_CHARS) {
          panel.hide();
        } else {
          searchEl.close();
          panel.show();
        }
      });
    }

    function links() {
      return Array.prototype.slice.call(results.querySelectorAll('a[href]'));
    }

    // Set while focus is moved back to the box on purpose, so it doesn't reopen.
    var refocusing = false;

    searchEl.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (!isOpen(results) && !panelOpen()) return;
        closeAll();
        refocusing = true;
        input.focus();
        refocusing = false;
        event.preventDefault();
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      if (!isOpen(results) && !panelOpen()) return;
      var items = panelOpen() ? panel.links() : links();
      if (!items.length) return;
      var index = items.indexOf(document.activeElement);
      var next;
      if (event.key === 'ArrowDown') {
        next = index < items.length - 1 ? items[index + 1] : null;
      } else if (index === 0) {
        next = input;
      } else if (index > 0) {
        next = items[index - 1];
      }
      if (next) {
        next.focus();
        event.preventDefault();
      }
    });

    // Tabbing out closes. A tap that moves focus nowhere (relatedTarget null) is
    // left to the outside-click handler, so a tap on a result link still lands.
    searchEl.addEventListener('focusout', function (event) {
      var to = event.relatedTarget;
      if (to && !searchEl.contains(to)) closeAll();
    });

    document.addEventListener('click', function (event) {
      if (!searchEl.contains(event.target) && (isOpen(results) || panelOpen())) closeAll();
    });

    // Coming back to a box that still holds a query shows its results again; an
    // empty box shows the panel. Click covers a box that kept focus after Escape.
    function reopen() {
      if (refocusing) return;
      if (input.value.trim().length >= MIN_CHARS) {
        if (results.innerHTML.trim() !== '' && !isOpen(results)) searchEl.open();
      } else if (panel) {
        panel.show();
      }
    }
    input.addEventListener('focus', reopen);
    input.addEventListener('click', reopen);
  }

  function start() {
    var definition = window.customElements && customElements.get('predictive-search');
    if (definition) patchElement(definition.prototype);
    document.querySelectorAll('predictive-search').forEach(initSearch);
  }

  // theme.js defines <predictive-search> once the DOM is ready; wait for it so the
  // patch is in place before anyone types. Without the element (predictive search
  // turned off) only the plain behaviour of the form remains.
  function whenReady() {
    var product = currentProduct();
    if (product) recordProduct(product);
    if (!window.customElements || !document.querySelector('predictive-search')) return;
    customElements.whenDefined('predictive-search').then(start);
  }

  // Theme editor: selecting a "Search panel link" block opens the panel it sits in,
  // and a re-rendered header gets its search boxes wired up again.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (event) {
      var searchEl = event.target.closest && event.target.closest('predictive-search');
      if (searchEl && searchEl.wrPanel) searchEl.wrPanel.show();
    });
    document.addEventListener('shopify:block:deselect', function (event) {
      var searchEl = event.target.closest && event.target.closest('predictive-search');
      if (searchEl && searchEl.wrPanel) searchEl.wrPanel.hide();
    });
    document.addEventListener('shopify:section:load', function (event) {
      if (!window.customElements || !customElements.get('predictive-search')) return;
      event.target.querySelectorAll('predictive-search').forEach(initSearch);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', whenReady);
  } else {
    whenReady();
  }
})();
